var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 9.49992H7.66683V10.8333H6.3335V9.49992ZM6.3335 4.16658H7.66683V8.16658H6.3335V4.16658ZM6.9935 0.833252C3.3135 0.833252 0.333496 3.81992 0.333496 7.49992C0.333496 11.1799 3.3135 14.1666 6.9935 14.1666C10.6802 14.1666 13.6668 11.1799 13.6668 7.49992C13.6668 3.81992 10.6802 0.833252 6.9935 0.833252ZM7.00016 12.8333C4.0535 12.8333 1.66683 10.4466 1.66683 7.49992C1.66683 4.55325 4.0535 2.16659 7.00016 2.16659C9.94683 2.16659 12.3335 4.55325 12.3335 7.49992C12.3335 10.4466 9.94683 12.8333 7.00016 12.8333Z",
    fill: "#E1338D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9bc51874.svg";
export { ForwardRef as ReactComponent };